import { AppDispatch } from 'store';
import { clearImpressionDesignsSent } from 'utils/gtm/gtmProductImpressionEvent';
import { setGtmProductsDataAction } from '../slice';

const resetGtmProductsDataOperation = () => (dispatch: AppDispatch) => {
  clearImpressionDesignsSent();
  dispatch(
    setGtmProductsDataAction({
      gtmProducts: [],
      merge: false,
    }),
  );
};

export default resetGtmProductsDataOperation;
